import React, { Component } from 'react';
import styled from 'styled-components';

class CloseIcon extends Component {
    render() {
        const { className } = this.props;

        return (
            <SVG className={className} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L11 11M21 21L11 11M11 11L1 21M11 11L21 1" />
            </SVG>
        );
    }
}

const SVG = styled.svg`
    stroke: white;
    stroke-width: 1.5;
`;

export default CloseIcon;
